import type {MultiThesaurusValue} from 'sceneExtensions/extensions/multiThesaurusEdit/types';
import type {ThesaurusId} from 'services/thesaurus/types';
import type {MultiEditValue, MultiThesaurusMaps} from '../types';
import {mapNodeIdsToThesaurusValue} from '../../editThesaurus/functions';

export const mapMultiNodeIdsToThesaurusValue = (
  thesaurusIds: ThesaurusId[],
  multiValue: MultiEditValue,
  maps: MultiThesaurusMaps,
): MultiThesaurusValue => {
  return thesaurusIds.reduce<MultiThesaurusValue>(
    (acc, id) => ({
      ...acc,
      [id]: mapNodeIdsToThesaurusValue(multiValue[id]!, maps[id]!.idToCode),
    }),
    {},
  );
};
